import { AxiosRequestConfig } from 'axios';
import { APIService } from '../api';
import { mergeConfig } from '../api/utils';
import { PaginatedResponse, PaginationParams } from '../pagination';
import { Platform } from '../platform/Platform';
import { ApparelCategory } from './ApparelCategory';
import { Model } from './Model';

interface IndexParams extends PaginationParams {
    q: string;
    category_id: number | string | string[] | number[];
    category_ids: number | string | string[] | number[];
    platform: string | Platform;
}

export class ApparelSubcategory extends Model {
    public readonly blueprint = ApparelSubcategory;
    public readonly endpoint = APIService.createEndpoint('apparel-subcategories');

    public id: number;
    public name: string;
    public slug: string;
    public default_sku_id: number;
    public category_id: number;
    public category: ApparelCategory;

    public static async getSubcategories(
        params?: Partial<IndexParams>,
        config?: AxiosRequestConfig,
    ): Promise<PaginatedResponse<ApparelSubcategory>> {
        const model = new ApparelSubcategory();
        const { data } = await model.endpoint.get(
            '',
            mergeConfig(config, {
                params,
            }),
        );

        return data;
    }

    public urlParam(): string | number {
        return this.slug || this.id;
    }
}
